import type { WorkOrderPrintJobStatus } from "../../../../../../../../../../../../../api/kehrblatt/letters"
import type { BackgroundJobProgressView } from "../../../../../../../../../../../_shared/_logic/job-progress-contract"

const formatTime = (value: string | null) => {
  if (!value) return null

  const date = new Date(value)

  if (Number.isNaN(date.getTime())) return null

  return date.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" })
}

export const projectPrintJobProgress = (
  status: WorkOrderPrintJobStatus | null,
  totalRowsFallback: number,
): BackgroundJobProgressView => {
  const totalRows = status?.total_rows ?? totalRowsFallback
  const processedRows = status?.processed_rows ?? 0
  const failed = status?.status === "failed" || status?.status === "expired"
  const succeeded = status?.status === "finished"
  const percent = totalRows > 0 ? Math.min(100, Math.round((processedRows / totalRows) * 100)) : 0
  const details = [
    { label: "Phase", value: status?.phase ? status.phase.replace(/_/g, " ") : "wartet" },
    { label: "Download", value: succeeded ? "Zustell-PDF bereit" : "Zustell-PDF wird vorbereitet" },
  ]
  const expiresAt = formatTime(status?.expires_at ?? null)

  if (expiresAt) details.push({ label: "Verfügbar bis", value: `${expiresAt} Uhr` })

  return {
    state: failed ? "failed" : succeeded ? "succeeded" : "running",
    eyebrow: failed ? "Zustell-PDF fehlgeschlagen" : "Zustell-PDF",
    headline: `${processedRows} von ${totalRows} Briefen vorbereitet`,
    percent,
    progressText: `${processedRows} von ${totalRows} Briefen vorbereitet`,
    ariaLabel: "Fortschritt Zustell-PDF",
    details,
    errorMessage: failed
      ? status?.error_message || status?.message || "Zustell-PDF konnte nicht vorbereitet werden."
      : null,
  }
}
